import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-info',
    templateUrl: './icon-info.component.html',
    styleUrls: ['./icon-info.component.scss'],
    standalone: false
})
export class IconInfoComponent implements OnInit {
  @Input() width = '20';
  @Input() height = '20';

  constructor() {}

  ngOnInit(): void {}
}
